import React, { Suspense, lazy } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { LayoutSplashScreen } from "../../../_metronic";

const DashboardPage = lazy(() =>
	import("./dashboard/DashboardPage")
);

const GroupPage = lazy(() =>
	import("./group/GroupPage")
);

const AdminPage = lazy(() =>
	import("./admin/AdminPage")
);

const UserPage = lazy(() =>
	import("./user/UserPage")
);

const ReferenciaPage = lazy(() =>
	import("./referencia/ReferenciaPage")
);

const OcppPage = lazy(() =>
	import("./ocpp/OcppPage")
);

const CarroPage = lazy(() =>
	import("./carro/CarroPage")
);

const EletropostoPage = lazy(() =>
	import("./eletroposto/EletropostoPage")
);

const RelatorioPage = lazy(() =>
	import("./relatorio/RelatorioPage")
);

export default function HomePage() {

	return (
		<Suspense fallback={<LayoutSplashScreen />}>
			<Switch>
				{
					<Redirect exact from="/" to="/dashboard" />
				}

				<Route path="/dashboard" component={DashboardPage} />
				<Route path="/group" component={GroupPage} />
				<Route path="/admin" component={AdminPage} />
				<Route path="/user" component={UserPage} />
				<Route path="/referencia" component={ReferenciaPage} />
				<Route path="/ocpp" component={OcppPage} />
				<Route path="/carros" component={CarroPage} />
				<Route path="/eletropostos" component={EletropostoPage} />
				<Route path="/relatorio" component={RelatorioPage} />

				<Redirect to="/error/error-v6" />
			</Switch>
		</Suspense>
	);
}
